import { render, staticRenderFns } from "./dg-nav.vue?vue&type=template&id=c21d21a8&scoped=true"
import script from "./dg-nav.vue?vue&type=script&lang=js"
export * from "./dg-nav.vue?vue&type=script&lang=js"
import style0 from "./dg-nav.vue?vue&type=style&index=0&id=c21d21a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21d21a8",
  null
  
)

export default component.exports